export const UPDATE_STORE = "updateStore";
export function updateStore(newStore) {
	return {
		type: UPDATE_STORE,
		payload: newStore,
	};
}
